import ShPopConfirm from '@/components/Helpers/ShPopConfirm';
import MessagePlayer from './MessagePlayer';

// @vue/component
export default {
  name: 'IvrSingleMessageItem',

  components: {
    ShPopConfirm,
    MessagePlayer,
  },

  props: {
    projectUuid: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    fileLabel: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: null,
    },
    message: {
      type: String,
      default: null,
    },
    file: {
      type: String,
      default: null,
    },
    overrideActions: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      editedMessage: null,
      editedFile: null,
      isDetailsVisible: false,
      messageFileIsLoaded: false,
    };
  },

  computed: {
    isSmessageExists() {
      return this.editedFile !== '0';
    },
  },

  mounted() {
    this.editedFile = this.file;
    this.editedMessage = this.message;
  },

  methods: {
    toggleDetails() {
      this.isDetailsVisible = !this.isDetailsVisible;
    },
    async generateAndSaveMessage() {
      const params = {
        project: this.projectUuid,
        [this.label]: this.editedMessage,
      };
      if (this.overrideActions) {
        this.$emit('generateAndSaveMessage', params);
        return;
      }
      await this.$store.dispatch('client/project/ivrBasicMessages/updateIvrMessages', params);
      this.$store.dispatch('client/project/ivrBasicMessages/getDetails', this.projectUuid);
    },
    async deleteMessage() {
      const params = {
        project: this.projectUuid,
        [this.label]: ',',
        [this.fileLabel]: '0',
      };
      if (this.overrideActions) {
        this.$emit('deleteMessage', params);
        return;
      }
      await this.$store.dispatch('client/project/ivrBasicMessages/updateIvrMessages', params);
      this.$store.dispatch('client/project/ivrBasicMessages/getDetails', this.projectUuid);
    },
  },
};
